function Payment(paymentType, reasonCode, reasonDescription, processorTransactionId, orderId, orderNumber, extendedData, billingAddress, shippingAddress) {
	this.Type = paymentType;
	if(extendedData){
		this.ExtendedData = extendedData;
	}
	if(processorTransactionId){
		this.ProcessorTransactionId = processorTransactionId;		
	}
	if(reasonCode){
		this.ReasonCode = reasonCode;
	}
	if(reasonDescription || reasonDescription === ""){
		this.ReasonDescription = reasonDescription;
	}

	if(orderId !== undefined){
		this.OrderId = orderId;
	}
	if(orderNumber !== undefined){
		this.OrderNumber = orderNumber
	}
	if(billingAddress !== undefined && typeof billingAddress === 'object'){
		this.BillingAddress = billingAddress
	}
	if(shippingAddress !== undefined && typeof shippingAddress === 'object'){
		this.ShippingAddress = shippingAddress
	}
}

module.exports = Payment;


//////////////////
// WEBPACK FOOTER
// ./models/payment.js
// module id = 46
// module chunks = 0 5 20